<template>
  <v-row class='social-row' justify="center">
    <div v-for="social in socialButtons" v-bind:key="social.key" :class="social.class">
      <a :href="social.href" target="_blank">
        <v-img
          :alt="social.alt"
          :src="social.image"
          :min-height="social.height"
          :min-width="social.width"
          :max-height="social.height"
          :max-width="social.width"
          :height="social.height"
          :width="social.width"
        >
        </v-img>
      </a>
    </div>
  </v-row>
</template>

<script>
export default {
  name: "rw-social-buttons",

  created(){
    this.socialButtons.push({
        id: 2,
        alt: "Facebook",
        class: "icon",
        height: 36,
        width: 36,
        href: "https://www.facebook.com/aquaductroofing",
        image: this.facebook,
        source: "facebook",
    })
    this.socialButtons.push({
        id: 4,
        alt: "LinkedIn",
        class: "icon",
        height: 36,
        width: 36,
        href: "https://www.linkedin.com/company/aquaduct-roof-&-gutters/",
        image: this.linkedin,
        source: "linkedin",
    })
  },

  data: () => ({
    facebook: require("@/assets/facebook.png"),
    googlePlus: require("@/assets/google-plus.png"),
    linkedin: require("@/assets/linkedin.png"),
    socialButtons: [],
    twitter: require("@/assets/twitter.png"),
    yelp: require("@/assets/yelp.png"),
    youTube: require("@/assets/you-tube.png"),
  }),
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 5px;
  margin-top:25px;
}
.button {
  margin: 2px;
}
.button:hover {
  cursor: pointer;
}
.ransford {
  margin-left: 20px;
  margin-top: 12px
}
.social-row {
  height: 80px;
}
</style>
